import React from "react";
import { graphql } from "gatsby";
import Seo from "../components/seo";
import Modules from "../components/modules";
// import ScrollerTexteImages from "../components/modules/ScrollerTexteImages";
// import Scrollspy from "react-scrollspy";
import Aside from "../components/Aside";
import MaskFlash from "../components/MaskFlash";
import { _localizeField } from "../core/utils";

import mask from "../images/mask.png";

export const query = graphql`
  query PageBySlug($slug: String!) {
    sanityPageModulaire(slug: { current: { eq: $slug } }) {
      home
      title
      seo {
        metaTitle
        metaDescription
      }
      # modules {
      #   _type
      #   _key
      #   title {
      #     fr
      #     en
      #   }
      #   texte: _rawTexte
      #   images: _rawImages(resolveReferences: { maxDepth: 10 })
      # }
      modules {
        ... on SanityTexteUI {
          _type
          _key
          title {
            fr
            en
          }
          texte: _rawTexte
        }
        ... on SanityTexteImagesUI {
          _type
          _key
          title {
            fr
            en
          }
          texte: _rawTexte
          images: _rawImages(resolveReferences: { maxDepth: 10 })
        }
      }
      masks {
        asset {
          url
        }
      }
    }
  }
`;

const PageModulaire = ({ data }) => {
  const { home, seo, title, modules, masks } = data.sanityPageModulaire;
  // console.log(modules);

  const _getAsideNav = () =>
    modules.map((el) => {
      return { id: el._key, title: _localizeField(el.title) };
    });

  const _getRandomTarget = () => {
    const filtered = modules.filter((el, i) => {
      if (i % 2 == 0) return el;
    });
    return filtered.map((el, i) => el._key).toString();
  };

  return (
    <div className='page'>
      {seo && (
        <Seo
          pageTitle={seo.metaTitle}
          pageDescription={seo.metaDescription}
          // pageImage={image_featured.url}
          template={`template-modulaire ${home ? "home" : ""} `}
          page={!home}
        />
      )}
      {/* <h1>t: {title}</h1> */}
      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}

      {modules && (
        <>
          <Modules input={modules} />
          {home && <Aside input={_getAsideNav()} />}
          {/* <MaskFlash input={masks} target={_getRandomTarget()} /> */}
          {home && (
            <div className='mask mbM hidden-sm'>
              <img src={mask} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PageModulaire;
